'use client';
import { type FC, useEffect } from 'react';
import { useLoggedIn } from '@/tracking/use-logged-in';
import { useDataDog } from './use-data-dog-rum';
import { useTrackVirtPathAndPageMeta } from './use-track-virt-path-and-page-meta';

type TrackingProps = {
  dataDogViewName: string;
  state: {
    [key: string]: string | undefined;
  };
  virtPathViewName: string;
};

export const Tracking: FC<TrackingProps> = ({ dataDogViewName, state, virtPathViewName }) => {
  const trackVirtPathAndPageMeta = useTrackVirtPathAndPageMeta();

  const loggedIn = useLoggedIn();

  useDataDog({
    checkout: 'Dynamic',
    viewName: dataDogViewName,
    state,
  });

  useEffect(() => {
    trackVirtPathAndPageMeta(
      `${loggedIn ? '/serviceview' : ''}/checkout-b2c-strom-${virtPathViewName.replaceAll(' ', '-').toLocaleLowerCase()}-dynamic/`,
      `${loggedIn ? 'Serviceview ' : ''}Checkout B2C Strom ${virtPathViewName} Dynamic`,
      'Other',
    );
  }, [loggedIn, trackVirtPathAndPageMeta, virtPathViewName]);

  return null;
};
